import { Product } from 'common/accounting/AccountingDocuments';

export const awsRegions = [
  { region: 'us-east-1', name: 'US East (N. Virginia)' },
  { region: 'us-east-2', name: 'US East (Ohio)' },
  { region: 'us-west-1', name: 'US West (N. California)' },
  { region: 'us-west-2', name: 'US West (Oregon)' },
  { region: 'ca-central-1', name: 'Canada (Central)' },
  { region: 'eu-west-1', name: 'EU (Ireland)' },
  { region: 'eu-central-1', name: 'EU (Frankfurt)' },
  { region: 'eu-west-2', name: 'EU (London)' },
  { region: 'eu-west-3', name: 'EU (Paris)' },
  { region: 'eu-north-1', name: 'EU (Stockholm)' },
  { region: 'ap-northeast-1', name: 'Asia Pacific (Tokyo)' },
  { region: 'ap-northeast-2', name: 'Asia Pacific (Seoul)' },
  { region: 'ap-southeast-1', name: 'Asia Pacific (Singapore)' },
  { region: 'ap-southeast-2', name: 'Asia Pacific (Sydney)' },
  { region: 'ap-south-1', name: 'Asia Pacific (Mumbai)' },
  { region: 'sa-east-1', name: 'South America (São Paulo)' },
  //{ region: 'us-gov-west-1', name: 'US Gov West 1' },
  //{ region: 'us-gov-east-1', name: 'US Gov East 1' },
];

export enum CoreInstanceType {
  XSMALL = 2,
  SMALL = 3,
  MEDIUM = 4,
  LARGE = 5,
  XLARGE = 6,
}

export const CoreInstanceTypeTexts = {
  [CoreInstanceType.XSMALL]: 'XS',
  [CoreInstanceType.SMALL]: 'S',
  [CoreInstanceType.MEDIUM]: 'M',
  [CoreInstanceType.LARGE]: 'L',
  [CoreInstanceType.XLARGE]: 'XL',
};

export interface CoreInstanceTypeSettings {
  coreInstanceTypeID: CoreInstanceType;
  name: string;
  nativeInstanceType: string;
  rootStorageSizeGiB: number;
  memoryGiB: number;
  vCpu: number;
  productID: Product;
}

export const coreInstanceTypeSettings: CoreInstanceTypeSettings[] = [
  // TODO: Disabled (for now)
  // {
  //   coreInstanceTypeID: CoreInstanceType.XSMALL,
  //   name: CoreInstanceTypeTexts[CoreInstanceType.XSMALL],
  //   nativeInstanceType: 't4g.small',
  //   rootStorageSizeGiB: 20,
  //   memoryGiB: 2,
  //   vCpu: 2,
  //   productID: Product.INSTANCE_XSMALL,
  // },
  {
    coreInstanceTypeID: CoreInstanceType.SMALL,
    name: CoreInstanceTypeTexts[CoreInstanceType.SMALL],
    nativeInstanceType: 't4g.medium',
    rootStorageSizeGiB: 40,
    memoryGiB: 4,
    vCpu: 2,
    productID: Product.INSTANCE_SMALL,
  },
  {
    coreInstanceTypeID: CoreInstanceType.MEDIUM,
    name: CoreInstanceTypeTexts[CoreInstanceType.MEDIUM],
    nativeInstanceType: 't4g.large',
    rootStorageSizeGiB: 80,
    memoryGiB: 8,
    vCpu: 2,
    productID: Product.INSTANCE_MEDIUM,
  },
  {
    coreInstanceTypeID: CoreInstanceType.LARGE,
    name: CoreInstanceTypeTexts[CoreInstanceType.LARGE],
    nativeInstanceType: 't4g.xlarge',
    rootStorageSizeGiB: 100,
    memoryGiB: 16,
    vCpu: 4,
    productID: Product.INSTANCE_LARGE,
  },
  {
    coreInstanceTypeID: CoreInstanceType.XLARGE,
    name: CoreInstanceTypeTexts[CoreInstanceType.XLARGE],
    nativeInstanceType: 't4g.2xlarge',
    rootStorageSizeGiB: 200,
    memoryGiB: 32,
    vCpu: 8,
    productID: Product.INSTANCE_XLARGE,
  },
];
